var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.3608 18.8238C24.2522 18.9602 23.2494 19.4142 22.8002 19.7672C13.3437 33.321 21.7491 51.0418 32.9086 61.1337L41.6456 52.3143C41.6456 52.3143 36.2323 46.9459 34.3006 42.768V37.0178L37.1757 34.1427C37.1757 34.1427 38.3606 31.1257 37.4789 28.6059L34.3006 19.7672C33.4342 18.8687 26.4695 18.6874 25.3608 18.8238ZM41.6456 52.3143L32.9086 61.1337C43.4788 71.9633 66.6033 80.524 74.3275 71.2945C74.3275 71.2945 76.349 61.7514 74.552 60.0187L65.4887 56.6157C62.4607 55.4482 59.9519 56.9189 59.9519 56.9189L57.0768 59.794H51.3266C46.7369 57.8998 41.6456 52.3143 41.6456 52.3143L41.6456 52.3143Z","fill":"#4E5D73"}));
}

Phone.defaultProps = {"width":"94","height":"94","viewBox":"0 0 94 94","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
